import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Input, Form, Radio, RadioGroup } from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'

export default function InviteToProjectForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  const [isShowInput, setIsShowInput] = useState(_schema?.acceptType ? false : true)
  const [acceptType, setAcceptType] = useState(_schema?.acceptType?.value || 1)

  return (
    <>
      <Form>
        <Panel style={{ marginTop: -10 }}>
          {schema.invitedInfo && (
            <Row style={{ marginBottom: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 10 }}>
                <p>
                  <b>ข้อมูลผู้ได้รับคำเชิญ</b>
                </p>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <p>{`${schema.firstName.label}-${schema.lastName.label} : ${schema.invitedInfo.firstName} ${schema.invitedInfo.lastName} `}</p>
                <p>{`${schema.department.label} : ${schema.invitedInfo.department} `}</p>
                <p>{`${schema.email.label} : ${schema.invitedInfo.email}`}</p>
              </Col>
            </Row>
          )}

          {schema.acceptType && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ErrorMessage error={errors[schema.acceptType.name]} />
                <Controller
                  name={schema.acceptType.name}
                  control={control}
                  defaultValue={acceptType}
                  value={acceptType}
                  rule={register(isValidators(schema.acceptType.validators))}
                  render={(props) => {
                    return (
                      <RadioGroup
                        inline
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setAcceptType(value)
                          setIsShowInput(value == 3)
                        }}
                      >
                        {schema.acceptType.options.map((item) => (
                          <Radio
                            key={item.value}
                            value={item.value}
                            disabled={schema.acceptType.disabled}
                          >
                            {item.label}
                          </Radio>
                        ))}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            </Row>
          )}

          {isShowInput && (
            <Row>
              {schema.firstName && (
                <Col xs={24} sm={24} md={12} lg={6} style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[schema.firstName.name]} />
                  <ControlLabel>
                    {requiredFiled(schema.firstName.validators, schema.firstName.label)}
                  </ControlLabel>
                  <Input
                    name={schema.firstName.name}
                    defaultValue={schema.firstName.value}
                    placeholder={schema.firstName.hint || `ระบุ${schema.firstName.label}`}
                    inputRef={register(isValidators(schema.firstName.validators))}
                  />
                </Col>
              )}

              {schema.lastName && (
                <Col xs={24} sm={24} md={12} lg={6} style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[schema.lastName.name]} />
                  <ControlLabel>
                    {requiredFiled(schema.lastName.validators, schema.lastName.label)}
                  </ControlLabel>
                  <Input
                    name={schema.lastName.name}
                    defaultValue={schema.lastName.value}
                    placeholder={schema.lastName.hint || `ระบุ${schema.lastName.label}`}
                    inputRef={register(isValidators(schema.lastName.validators))}
                  />
                </Col>
              )}

              {schema.department && (
                <Col xs={24} sm={24} md={12} lg={6} style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[schema.department.name]} />
                  <ControlLabel>
                    {requiredFiled(schema.department.validators, schema.department.label)}
                  </ControlLabel>
                  <Input
                    name={schema.department.name}
                    defaultValue={schema.department.value}
                    placeholder={schema.department.hint || `ระบุ${schema.department.label}`}
                    inputRef={register(isValidators(schema.department.validators))}
                  />
                </Col>
              )}

              {schema.email && (
                <Col xs={24} sm={24} md={12} lg={6} style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[schema.email.name]} />
                  <ControlLabel>
                    {requiredFiled(schema.email.validators, schema.email.label)}
                  </ControlLabel>
                  <Input
                    name={schema.email.name}
                    defaultValue={schema.email.value}
                    placeholder={schema.email.hint || `ระบุ${schema.email.label}`}
                    inputRef={register(isValidators(schema.email.validators))}
                  />
                </Col>
              )}
            </Row>
          )}
        </Panel>
      </Form>
    </>
  )
}
